/** Bridge between axios (api/client) and the React session-expired modal */

let uiHandler = null;

export function registerSessionExpiryUI(handler) {
  uiHandler = typeof handler === "function" ? handler : null;
}

/**
 * @param {{ reason?: string, redirectUrl: string, portalLabel?: string }} payload
 * @returns {boolean} true if UI handled it (caller should not redirect immediately)
 */
export function notifySessionExpiryUI(payload) {
  if (uiHandler) {
    try {
      uiHandler(payload);
      return true;
    } catch (e) {
      console.warn("Session expiry UI handler failed", e);
    }
  }
  return false;
}
